import { State, Action, StateContext } from '@ngxs/store';
import { AddPermission, SetPermissions } from './app.actions';
import { Injectable, Injector } from '@angular/core';
import { UserFieldPermission } from '@app/areas/permissions/interfaces/permission';
import { ListModelState } from './list-model/list-model.state';
import { ListComponentState } from './list-component/list-component.state';
import { AppInjector } from '@app/base/app-injector';
import { ModulesState } from './modules/modules.state';

export interface AppStateModel {
    permissions: UserFieldPermission[];
}

const defaults: AppStateModel = {
    permissions: null
}

@State<AppStateModel>({
    name: 'avux',
    defaults: defaults,
    children: [
        ListModelState,
        ListComponentState,
        ModulesState
    ],
})

@Injectable()
export class AppState {

    constructor(
        injector: Injector
    ) {
        AppInjector.setInjector(injector);
    }

    @Action(SetPermissions) setPermissions(ctx: StateContext<AppStateModel>, action: SetPermissions) {
        const state = ctx.getState();
        ctx.setState({ ...state, permissions: action.payload });
    }

    @Action(AddPermission) addPermission(ctx: StateContext<AppStateModel>, action: AddPermission) {
        const state = ctx.getState();
        ctx.setState({ ...state, permissions: [...state.permissions || [], action.payload] });
    }

}

